import { sortArrayByKey } from '@/helpers'

export default {
  taskGroups: (state) => {
    return Object.values(state.taskGroups)
      .sort((a, b) => {
        if (a.position > 0 || b.position > 0) {
          return b.position - a.position
        }
        if (a.name > b.name) {
          return 1
        }
        if (a.name < b.name) {
          return -1
        }
        return 0
      })
  },
  taskGroupsPromoted: (state, getters) => {
    let result = []
    for (let value of getters['taskGroups']) {
      // Tasks are in sorted order, as soon as we find a <0, abort the loop
      if (value.position < 0) {
        break
      }
      result.push(value)
    }
    return result.sort(sortArrayByKey('name'))
  },
  taskOperations: (state) => {
    return state.taskOperations
  },
  lastTaskGroupPosition: (state, getters) => {
    return getters['taskGroupsPromoted'].length > 0 ? getters['taskGroupsPromoted'][getters['taskGroupsPromoted'].length - 1].position : 0
  },
  recentTasks: (state) => (taskGroupId) => {
    if (state.recentlyCreatedTaskGroups[taskGroupId] === undefined) {
      return state.taskGroups[taskGroupId].task_list
    }
    return state.recentlyCreatedTaskGroups[taskGroupId].task_list
  },
  taskTypeByName: (state) => (taskName) => {
    for (let task of Object.values(state.taskTypes)) {
      if (taskName === task.name) {
        return task
      }
    }

    return null
  },
  tasksDuration: (state) => (tasks) => {
    let duration = 0

    tasks.forEach((task) => {
      if (task) {
        duration += state.taskTypes[task].duration
      }
    })

    return duration
  },
  taskTypes: (state) => (filter = null) => {
    if (!filter) {
      return state.taskTypes
    }

    let taskTypes = []

    filter.forEach((task) => {
      if (task) {
        taskTypes.push(state.taskTypes[task])
      }
    })

    return taskTypes
  },
  taskInfo: (state) => (taskGroupId) => {
    return taskGroupId in state.taskGroups
      ? state.taskGroups[taskGroupId]
      : taskGroupId in state.recentlyCreatedTaskGroups
        ? state.recentlyCreatedTaskGroups[taskGroupId]
        : {}
  },
  tasksList: (state, getters) => (taskGroupId) => {
    return taskGroupId in state.taskGroups
      ? state.taskGroups[taskGroupId].task_list
      : taskGroupId in state.recentlyCreatedTaskGroups
        ? getters.recentTasks(taskGroupId)
        : []
  }
}
